export default __webpack_public_path__ + "media/images/react_icons/explore-75edd0a733b340ec961f73c25c361f87.svg";